export default "__VITE_ASSET__CDFlxUSM__"